<template>
    <div class="banner">
        <div class="banner_text" :class="titleCn == '新闻资讯'?'black':''">
            <p>{{titleEn}}</p>
            <h3>{{titleCn}}</h3>
        </div>
        <img :src='img'>
    </div>
</template>
<script>
    export default {
        name:'banner',
        props:{
            img:String,
            titleCn:String,
            titleEn:String,
        }
    }
</script>
<style lang="scss" scoped>
    .black{
        p{
            color: #333 !important;
        }
        h3{
            color: #333 !important;
        }
    }
    .banner{
        position: relative;
        width: 100%;
        img{
            width: 100%;
            display:block;
        }
        .banner_text{
            padding-top: 142px;
            position: absolute;
            width:100%;
           text-align:center;
           p{
            margin: 0;
            font-weight:700;
            font-size:26px;
            color:#fff;
            text-transform: uppercase;
           }
           h3{
            margin: 0;
            font-weight:400;
            font-size:20px;
            color: #fff;
            margin-top: 16px;
           }
        }
    }
</style>